import React, { useState } from 'react';

function IngredientSidebar({ onFindRecipes, loading, onPrint }) {
  const [ingredients, setIngredients] = useState('');

  const handleIngredientChange = (event) => {
    setIngredients(event.target.value);
  };

  const handleFindRecipes = () => {
    onFindRecipes(ingredients);
  };

  return (
    <div className="sidebar" style={{ width: '240px', flexShrink: 0, boxSizing: 'border-box', overflowX: 'hidden', padding: '15px', backgroundColor: '#e8f6f3', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', gap: '15px', overflowY: 'auto' }}>
      <h2 style={{ color: '#16a085', borderBottom: '2px solid #1abc9c', paddingBottom: '10px', marginTop: 0 }}>Ingredients</h2>
      <textarea
        placeholder="Enter your ingredients, one per line..."
        value={ingredients}
        onChange={handleIngredientChange}
        style={{ flex: 1, minHeight: '150px', padding: '12px', borderRadius: '8px', border: '1px solid #bdc3c7', resize: 'vertical', fontFamily: 'inherit', fontSize: '14px', outline: 'none', boxSizing: 'border-box', width: '100%' }}
      />
      <button 
        onClick={handleFindRecipes} 
        disabled={loading}
        style={{
          padding: '12px 20px',
          backgroundColor: loading ? '#95a5a6' : '#1abc9c',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: 'bold',
          cursor: loading ? 'not-allowed' : 'pointer',
          transition: 'background-color 0.3s',
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
        }}
      >
        {loading ? 'Finding...' : 'Find Recipes'}
      </button>
      {onPrint && (
        <button 
          onClick={onPrint} 
          style={{
            padding: '12px 20px',
            backgroundColor: '#34495e',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
          }}
        >
          Print Menu
        </button>
      )}
    </div>
  );
}

export default IngredientSidebar;
